import React from 'react'
import PropTypes from 'prop-types'
import DatePicker from 'react-datepicker'
import Input from './Input'
import 'react-datepicker/dist/react-datepicker.css';
import './style.css'

export default class Calendar extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    dateFormat: PropTypes.string.isRequired,
    value: PropTypes.instanceOf(Date),
    onChange: PropTypes.func,
    style: PropTypes.object,
    minDate: PropTypes.instanceOf(Date),
    maxDate: PropTypes.instanceOf(Date)
  }

  render() {
    const { name, value, onChange, style, dateFormat, minDate, maxDate } = this.props

    return (
      <DatePicker
        inline
        name={name}
        onChange={onChange}
        selected={value}
        dateFormat={dateFormat}
        minDate={minDate}
        maxDate={maxDate}
      />
    )
  }
}

const styles = {
}
